//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../Features/Features.SheetMetal.FlexTransitionAttachmentListItemBuilderList.js";
import "../Features/Features.SheetMetal.BendOptions.js";
import "../no/SelectEdge.js";
import "../no/Expression.js";
import "../Features/Features.SheetMetal.MultiThicknessBuilder.js";
import "../no/SelectISurface.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[0,"AlternateSolution",1,0],[1,"AttachmentList",0,"Features.SheetMetal.FlexTransitionAttachmentListItemBuilderList",0],[1,"BendOptionsOfSketchedTransition",0,"Features.SheetMetal.BendOptions",0],[1,"EndEdge",0,"SelectEdge",0],[1,"EndEdgeLateralOffset",0,"Expression",0],[0,"FlexEndpoint",1,"Point",0],[1,"FlexLength",0,"Expression",0],[0,"FlexLengthType",1,0],[0,"FoldBendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"FoldTransitionType",1,0],[0,"HintPoints",1,"Section",0],[0,"HintPointsSketchFrecTag",1,"Features.SketchFeature",0],[0,"InsetType",1,0],[1,"Length",0,"Expression",0],[1,"MultiThicknessProperty",0,"Features.SheetMetal.MultiThicknessBuilder",0],[1,"Plane",0,"SelectISurface",0],[0,"Point",1,"Point",0],[0,"ReferenceGeometryPlane",1,"Plane",0],[0,"ScaleFactor",1,0],[0,"Section",1,"Section",0],[0,"StartAndEndParametersEqual",1,0],[1,"StartEdge",0,"SelectEdge",0],[1,"StartEdgeLateralOffset",0,"Expression",0],[0,"TrimOrExtendToBend",1,0],[0,"Type",1,0],[1,"Width",0,"Expression",0],[0,"WidthDirection",1,0],[0,"WidthType",1,0],[0,"ZuEndEdgeBendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"ZuStartEdgeBendOptions",0,"Features.SheetMetal.BendOptions",0]],[[[],"CreateFlexTransitionAttachmentListItemBuilder",{R_:{listBuilder:"Features.SheetMetal.FlexTransitionAttachmentListItemBuilder"}},0,0],[["sketch"],"DoPreProcessBeforeSketchReattach",{R_:{isOffsetDataChanged:''}},1,0]],[]];
SPLM.Features.SheetMetal.BridgeTransitionBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.BridgeTransitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.BridgeTransitionBuilder.WidthOptions = Object.freeze({
    "Finite" : "Finite", "Symmetric" : "Symmetric", "FullStartEdge" : "FullStartEdge", "FullEndEdge" : "FullEndEdge", "FullBothEdges" : "FullBothEdges"});

SPLM.Features.SheetMetal.BridgeTransitionBuilder.TypeOptions = Object.freeze({
    "Zu" : "Zu", "Fold" : "Fold", "Flex" : "Flex", "Sketched" : "Sketched"});

SPLM.Features.SheetMetal.BridgeTransitionBuilder.WidthDirectionOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.BridgeTransitionBuilder.InsetOptions = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside"});

SPLM.Features.SheetMetal.BridgeTransitionBuilder.FoldTransitionTypeOptions = Object.freeze({
    "Length" : "Length", "Bend" : "Bend"});

SPLM.Features.SheetMetal.BridgeTransitionBuilder.FlexLengthOptions = Object.freeze({
    "ScaleFactor" : "ScaleFactor", "Value" : "Value"});

export default SPLM;